/**
 * The "Learn" menu. See lib/navigation/nav-manifest.js for the entry shape and
 * the vocabulary `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const LEARN_ITEMS = [
  {
    href: "/playbook",
    label: "Playbook",
    iconName: "IoBookOutline",
    requires: "workspace",
    subItems: [
      {
        href: "/playbook#company-overview",
        label: "Company Overview",
        iconName: "IoBusinessOutline",
      },
      {
        href: "/playbook#positioning",
        label: "Positioning",
        iconName: "IoFlagOutline",
      },
      {
        href: "/playbook#glossary",
        label: "Glossary",
        iconName: "IoBookOutline",
      },
      {
        href: "/playbook#our-content-faq",
        label: "Q&As",
        iconName: "IoHelpCircleOutline",
      },
      {
        href: "/playbook#fbiv",
        label: "Capability Maps",
        iconName: "RxTarget",
      },
      {
        href: "/playbook#messaging",
        label: "Messaging (Pitches)",
        iconName: "HiOutlinePresentationChartBar",
      },
      {
        href: "/playbook#objections",
        label: "Objections",
        iconName: "HiNoSymbol",
      },
      {
        href: "/playbook#discovery",
        label: "Discovery",
        iconName: "CiMap",
      },
      {
        href: "/playbook#cold-call",
        label: "Outbound & Inbound",
        iconName: "IoCallOutline",
      },
      {
        href: "/playbook#plays",
        label: "Plays",
        iconName: "LiaTheaterMasksSolid",
      },
      {
        href: "/playbook#lessons",
        label: "Lessons",
        iconName: "IoDocumentTextOutline",
      },
    ],
  },
  {
    href: "/dashboard/learning-paths",
    label: "Learning Paths",
    iconName: "SlGraduation",
    requires: "workspace",
  },
  {
    href: "/dashboard/tests",
    label: "Tests",
    iconName: "IoDocumentTextOutline",
    requires: "workspace",
  },
  {
    href: "/dashboard/assignments",
    label: "Assignments",
    iconName: "ClipboardList",
    requires: "workspace",
  },
  {
    label: "My Training",
    iconName: "HiOutlineClipboardDocumentCheck",
    requires: "user",
    subItems: [
      {
        href: "/training",
        label: "Training Home",
        iconName: "HiOutlineClipboardDocumentCheck",
      },
      {
        href: "/chats",
        label: "Chats",
        iconName: "IoChatbubbleOutline",
        requires: "workspace",
      },
    ],
  },
  {
    href: "/questions",
    label: "Questions",
    iconName: "IoHelpCircleOutline",
    requires: "workspace",
  },
  {
    href: "/stories",
    label: "Stories",
    iconName: "IoBookOutline",
    requires: "stories",
  },
];
